import { useState } from 'react';

export default function useTrigger(props?: { initialValueNull?: boolean }): [number | null, () => void] {
  const [triggerValue, setTriggerValue] = useState(props?.initialValueNull ? null : Date.now());

  return [triggerValue, () => setTriggerValue(Date.now())];
}
